import { gql } from "@apollo/client";

import { OrganizationMemberFragment } from "./get-organization-members-query";

export default gql`
  ${OrganizationMemberFragment}
  mutation updateMemberMutation(
    $organizationId: Int!
    $role: OrganizationRole
    $userId: Int!
    $startDate: String
    $employeeId: String
    $position: String
    $jobLevel: String
    $location: String
    $membershipStatus: AccountToOrganizationMembershipStatus
  ) {
    updateOrganizationMembership(
      organizationId: $organizationId
      userId: $userId
      role: $role
      startDate: $startDate
      employeeId: $employeeId
      position: $position
      jobLevel: $jobLevel
      location: $location
      membershipStatus: $membershipStatus
    ) {
      member {
        ...OrganizationMember
      }
    }
  }
`;
